import { c as _c } from "react/compiler-runtime";
import CustomTooltip from "@/components/utils/tooltip/CustomTooltip";
import { formatCompactNumber } from "../utils/formatNumbers";
interface MetricSparklineProps {
  readonly data: number[];
  readonly color: string;
  readonly dates?: number[] | undefined;
}
function formatDate(timestamp: number): string {
  return new Date(timestamp).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric"
  });
}
export default function MetricSparkline(t0) {
  const $ = _c(11);
  const {
    data,
    color,
    dates
  } = t0;
  if (data.length === 0) {
    return null;
  }
  const maxValue = Math.max(...data);
  let t1;
  if ($[0] !== color || $[1] !== data || $[2] !== dates || $[3] !== maxValue) {
    let t2;
    if ($[5] !== color || $[6] !== dates || $[7] !== maxValue) {
      t2 = (value, index) => {
        const height = maxValue > 0 ? value / maxValue * 100 : 0;
        const date = dates?.[index];
        const tooltipContent = typeof date === "number" ? `${formatDate(date)}: ${formatCompactNumber(value)}` : formatCompactNumber(value);
        return <CustomTooltip key={index} content={tooltipContent} placement="top"><div className={`tw-max-w-1.5 tw-flex-1 tw-rounded-t tw-grayscale tw-transition-all tw-duration-300 group-hover:tw-grayscale-0 hover:tw-opacity-80 ${color}`} style={{
            height: `${Math.max(height, 3)}%`
          }} /></CustomTooltip>;
      };
      $[5] = color;
      $[6] = dates;
      $[7] = maxValue;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = data.map(t2);
    $[0] = color;
    $[1] = data;
    $[2] = dates;
    $[3] = maxValue;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = <div className="tw-mt-auto tw-flex tw-h-12 tw-items-end tw-gap-px tw-pt-4">{t1}</div>;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}